export default function hasOutstandingExtraAttacks(combatants = [], caExtra = 0) {
  const extraSlugField = `ca_slug${caExtra}`

  return combatants.some(
    (combatant) => combatant?.extra === true && combatant?.[extraSlugField] === '',
  )
}
